import configData from "../configData.json";
import { RecaptchaRequest } from "../components/DataUtil";
declare global {
  interface Window {
    grecaptcha: any;
  }
}

const location = window.location;

let siteKeyValue: string = configData.PROD_RECAPTCHA_SITEKEY;

if (location !== null && location !== undefined) {
  if (location.hostname === "localhost") {
    //dev
    siteKeyValue = configData.RECAPTCHA_SITEKEY;
  }
}

export default class Recaptcha {
  action: string;
  constructor(action: string) {
    this.action = action;
    loadReCaptcha();
  }
  async getToken(): Promise<string> {
    let token = "";
    await window.grecaptcha
      .execute(siteKeyValue, { action: this.action })
      .then((res: string) => {
        token = res;
      });
    return token;
  }
  async getAssessment(
    tokenValue: string,
    successCallback: any,
    errorCallback: any
  ): Promise<any> {
    let uri: string =
      configData.RECAPTCHA_URI +
      configData.RECAPTCHA_PROJECT +
      "assessments?key=" +
      configData.GOOGLE_APIKEY;
    let payload: any = {
      event: {
        token: tokenValue,
        expectedAction: "USER_ACTION",
        siteKey: siteKeyValue,
      },
    };
    const jsonString = JSON.stringify(payload);
    RecaptchaRequest(uri, jsonString, successCallback, errorCallback);
  }
}

const loadReCaptcha = () => {
  const script = document.createElement("script");
  script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${siteKeyValue}`;
  document.body.appendChild(script);
};
